import React from 'react';
import { Spotlight } from '@teetsh/app/src/components/Spotlight/Spotlight';

export function PdfPreviewHighlight() {
  return (
    <Spotlight
      queryParam="openPdfPreview"
      targetSelector='[data-testid="edt-preview"]'
      duration={5000}
      delay={500}
    />
  );
}
